import * as React from 'react';
import * as I18n from 'i18n-js';
import {
  Shop,
  core_apimessages_Channel,
} from '../../schemas/rql';
import URLHelpers from '../shared/url_helpers';

interface IProps {
  shop?: Shop;
  userName?: string;
  channel?: core_apimessages_Channel;
}

export default class FeedbackShopLink extends React.Component<IProps, null> {
  shopUrl() {
    const { shop } = this.props;

    if (this.props.channel === core_apimessages_Channel.LP) {
      return URLHelpers.lpShopUrl(shop.slug);
    }

    return URLHelpers.shopPath(shop.slug);
  }

  renderShopLink() {
    return (
      <a className="shop-icon-link" href={this.shopUrl()}>{this.props.shop.name}</a>
    );
  }

  render() {
    return (
      <div>
        <span className="strong">
          {I18n.t('discovery.feedbackShopInfo.leavingFeedbackFor')}
        </span>
        <p className="strong">
          {this.props.shop ? this.renderShopLink() : this.props.userName}
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/feedbacks/feedback_shop_link.tsx